// extracted by mini-css-extract-plugin
export var center = "_1z-2";
export var clickableRow = "_1z-5";
export var expandedRow = "_1z-7";
export var hoverable = "_1z-4";
export var left = "_1z-1";
export var right = "_1z-3";
export var row = "_1z-0";
export var selectedRow = "_1z-6";
export var summaryRow = "_1z-8";